import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useSnackbar } from 'notistack';
import IStoreState from 'store/IStoreState';
import { NotificationKey } from '../stateManagement/state';
import { popupNotificationRemoved } from '../stateManagement/actionsCreator';

let displayed: NotificationKey[] = [];

const useNotifier = () => {
  const dispatch = useDispatch();
  const popupNotifications = useSelector(
    (store: IStoreState) => store.popupNotifications
  );
  const { enqueueSnackbar, closeSnackbar } = useSnackbar();

  const storeDisplayed = (id: NotificationKey) => {
    displayed = [...displayed, id];
  };

  const removeDisplayed = (id: NotificationKey) => {
    displayed = [...displayed.filter((key) => id !== key)];
  };

  useEffect(() => {
    popupNotifications.forEach(({ key, notification, dismissed = false }) => {
      if (dismissed) {
        closeSnackbar(key);
        return;
      }

      if (displayed.includes(key)) return;

      enqueueSnackbar(notification.message, {
        key,
        ...notification.options,
        variant:
          notification.severity === 'neutral' ? 'info' : notification.severity,
        onClose: (event, reason, myKey) => {
          if (notification.options?.onClose) {
            notification.options.onClose(event, reason, myKey);
          }
        },
        onExited: (_, myKey) => {
          dispatch(popupNotificationRemoved(myKey));
          removeDisplayed(myKey);
        },
      });

      storeDisplayed(key);
    });
  }, [popupNotifications, closeSnackbar, enqueueSnackbar, dispatch]);
};

export default useNotifier;
